<template>
  <div class="main-container">

      <end_info></end_info>
      <social_share v-if="$store.state.stages.twitter_share || $store.state.stages.facebook_share"></social_share>
      <subscribe_form  v-if="local_config.fields.phone != undefined || local_config.fields.email_optin != undefined"></subscribe_form>

  </div>
</template>

<script>
    import {form_methods, post_request, requests_methods, validation} from "../mixins/requests";
    import {elements_classes} from '../mixins/elements_classes'

    import Social_share from '../components/Social_share'
    import Subscribe_form from '../components/Subscribe_form'
    import End_info from '../components/End_info'

    export default {
        name: "failed",
        mixins: [post_request, requests_methods,form_methods, validation, elements_classes],
        components: {
            'social_share': Social_share,
            'subscribe_form': Subscribe_form,
            'end_info': End_info,
        },
        data(){
            return{
                // this_page: 'failed'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        }
    }
</script>

<style scoped>
</style>